import { NgModule } from '@angular/core';
import { HttpClientModule } from '@angular/common/http';
import { FormsModule } from '@angular/forms';
import { BrowserModule } from '@angular/platform-browser';
import { RouterModule } from '@angular/router';
import { AppComponent } from './app.component';
import { HomeComponent } from './home/home.component';
import { NavMenuComponent } from './nav-menu/nav-menu.component';
import { SharedModule } from './shared/shared.module';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { provideAnimationsAsync } from '@angular/platform-browser/animations/async';
import { MatFormFieldModule } from '@angular/material/form-field';
import { ConflictResultsComponent } from './conflict-results/conflict-results.component';
import { AuthComponent } from './auth/auth.component';
import { AuthGuard } from './shared/services/guards/auth-guard.service';
import { CreateMatterComponent } from './create-matter/create-matter.component';
import { ContactResultComponent } from './contact-result/contact-result.component';
import { CustomSnackbarComponent } from './custom-snackbar/custom-snackbar.component';
import { VerificationResultComponent } from './verification-result/verification-result.component';
import { NotificationComponent } from './notification/notification.component';
import { AdminPageComponent } from './admin-page/admin-page.component';
import { DocumentListComponent } from './document-list/document-list.component';
import { MatRadioModule } from '@angular/material/radio';
import { MatMenuModule } from '@angular/material/menu';
import { MatTooltipModule } from '@angular/material/tooltip';
import { SearchPopupComponent } from './search-popup/search-popup.component';
import { DropDownListModule } from '@syncfusion/ej2-angular-dropdowns'
import { ButtonModule } from '@syncfusion/ej2-angular-buttons'
import { WaitDialogComponent } from './shared/dialog/wait-dialog/wait-dialog.component';
import { ConfigurationDialogComponent } from './shared/dialog/configuration-dialog/configuration-dialog.component';
import { CountryFieldRequirementsComponent } from './country-field-requirements/country-field-requirements.component';

@NgModule({
    declarations: [
        AppComponent,
        NavMenuComponent,
        HomeComponent,
        ConflictResultsComponent,
        AuthComponent,
        CreateMatterComponent,
        ContactResultComponent,
        CustomSnackbarComponent,
        VerificationResultComponent,
        NotificationComponent,
        AdminPageComponent,
        DocumentListComponent,
        SearchPopupComponent,
        WaitDialogComponent,
        ConfigurationDialogComponent,
        CountryFieldRequirementsComponent
    ],
    imports: [
        BrowserAnimationsModule,
        BrowserModule.withServerTransition({ appId: 'ng-cli-universal' }),
        HttpClientModule,
        FormsModule,
        MatRadioModule,
        MatTooltipModule,
        MatMenuModule,
        RouterModule.forRoot([
            { path: '', component: HomeComponent, pathMatch: 'full', canActivate: [AuthGuard] },
            { path: 'home', component: HomeComponent, pathMatch: 'full', canActivate: [AuthGuard] },
            { path: 'auth', component: AuthComponent },
            { path: 'authorize', component: AuthComponent },
            { path: 'unauthorize', component: HomeComponent },
            { path: 'idverification', component: HomeComponent, canActivate: [AuthGuard] },
            { path: 'idverification/:matter/:code', component: HomeComponent, canActivate: [AuthGuard] },
            { path: 'admin', component:AdminPageComponent, canActivate:[AuthGuard]}
        ]),
        MatFormFieldModule,
        SharedModule,
        DropDownListModule,
        ButtonModule,
    ],
    providers: [
        provideAnimationsAsync()
    ],
    bootstrap: [AppComponent]
})
export class AppModule {

}
